import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { adminApi } from "../lib/api";
import { useSeo } from "../components/site/Layout";
import { STATUS_COLORS, LEAD_STATUSES, fmtDateTime } from "./AdminLayout";

export const StatusBadge = ({ status, testid }) => <span data-testid={testid} className={`inline-flex rounded-full px-3 py-1 text-sm font-semibold ${STATUS_COLORS[status] || "bg-slate-100"}`}>{status}</span>;

export default function AdminLeads() {
  useSeo("Demandes — admin");
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const source = params.get("source") || "";
  const [leads, setLeads] = useState(null);
  useEffect(() => {
    adminApi.get("/leads", { params: { status: status || undefined, source: source || undefined } }).then((r) => setLeads(r.data));
  }, [status, source]);
  const setFilter = (k, v) => { const p = new URLSearchParams(params); v ? p.set(k, v) : p.delete(k); setParams(p); };
  return (
    <div data-testid="admin-leads">
      <h1 className="text-3xl sm:text-4xl">Demandes</h1>
      <div className="mt-6 flex flex-wrap gap-4">
        <label className="flex items-center gap-2 font-semibold text-navy">Statut
          <select className="field-input py-2 w-auto" value={status} onChange={(e) => setFilter("status", e.target.value)} data-testid="leads-filter-status">
            <option value="">Tous</option>{LEAD_STATUSES.map((s) => <option key={s}>{s}</option>)}
          </select>
        </label>
        <label className="flex items-center gap-2 font-semibold text-navy">Source
          <select className="field-input py-2 w-auto" value={source} onChange={(e) => setFilter("source", e.target.value)} data-testid="leads-filter-source">
            <option value="">Toutes</option><option value="devis">devis</option><option value="rappel">rappel</option><option value="simulateur">simulateur</option>
          </select>
        </label>
      </div>
      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full min-w-[820px] text-left">
          <thead className="bg-slate-100 text-slate-700 text-sm uppercase tracking-wider">
            <tr><th className="p-4">Date</th><th className="p-4">Nom</th><th className="p-4">Source</th><th className="p-4">Profil</th><th className="p-4">Besoin</th><th className="p-4">CP</th><th className="p-4">Statut</th></tr>
          </thead>
          <tbody>
            {leads?.map((l) => (
              <tr key={l.id} className="border-t border-slate-100 hover:bg-mist-50" data-testid={`lead-row-${l.id}`}>
                <td className="p-4 text-sm text-slate-600 whitespace-nowrap">{fmtDateTime(l.created_at)}</td>
                <td className="p-4"><Link to={`/admin/demandes/${l.id}`} className="font-semibold text-navy link-u" data-testid={`lead-link-${l.id}`}>{l.name}</Link><div className="text-sm text-slate-600">{l.email}</div></td>
                <td className="p-4" data-testid={`lead-source-${l.id}`}>{l.source}</td>
                <td className="p-4">{l.profile}{l.organisation && <div className="text-sm text-slate-600">{l.organisation}</div>}</td>
                <td className="p-4 text-sm">{l.need}</td>
                <td className="p-4">{l.postal_code}</td>
                <td className="p-4"><StatusBadge status={l.status} testid={`lead-status-${l.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {leads && !leads.length && <p className="p-6 text-slate-600" data-testid="leads-empty">Aucune demande.</p>}
        {!leads && <p className="p-6 text-slate-600">Chargement…</p>}
      </div>
    </div>
  );
}
